module.exports = __webpack_public_path__ + "media/images/thumbs/biology/v_qv_duplicated_chromosome_eukaryotic_3-4eebd2376fe5dda279c44165efcf1ccc.jpg";